
import {
    GrpcService,
    HttpRequestDelegate,
} from "../../../grpc"

export interface GetPressureBalanceReportRequest {
    ticket?: string
}

export interface GetPressureStaticReportRequest {
    ticket?: string
}

export interface PressureBalanceNotificationResponse {
}

export interface BalanceReport {
    ticket: string
    state: ProcessingState
    code: number
    message: string
    valid: boolean
    footSide: FootSide
    data: Array<Data>
    creationTimestamp: number
    updateTimestamp: number
}

export interface CreatePressureBalanceResponse {
    ticket: string
}

export interface CreatePressureBalanceRequest {
    rawDataUrl?: string
    footSide: FootSide /* 左/右脚 */
}

export interface PressureStaticNotificationResponse {
}

export interface StaticReport {
    ticket: string
    state: ProcessingState
    code: number
    message: string
    valid: boolean
    thumbnail: Thumbnail
    left: Data
    right: Data
    cop: Cop
    creationTimestamp: number
    updateTimestamp: number
}

export interface Thumbnail {
    url: string
    copX: number
    copY: number
    centroidX: number
    centroidY: number
    forceMaxPointX: number
    forceMaxPointY: number
    width: number
    height: number
}

export interface ListActivateInfoResponse {
    activateInfoList: Array<LicenseActivationInfo>
}

export interface LicenseActivationInfo {
    code?: string
    licensePackageName?: string
    dateRange?: number
    count?: number
    activationTimestamp?: number
}

export interface ListActivateInfoRequest {
}

export interface CheckLatestVersionByTypeAndVersionResponse {
    hasLatest: boolean
    latestVersionInfo: VersionInfo
}

export interface CheckLatestVersionByTypeAndVersionRequest {
    versionType: VersionType
    version?: string
}

export interface ListLatestVersionInfoByTypeResponse {
    versionInfoList: Array<VersionInfo>
}

export interface ListLatestVersionInfoByTypeRequest {
    typeList: Array<VersionType>
}

export interface UpdateVersionInfoResponse {
    versionInfoId: number
}

export interface UpdateVersionInfoRequest {
    versionInfo: VersionInfo
}

export interface VersionInfo {
    id?: number
    type: VersionType
    version?: string
    description?: string
    downloadLink?: string
}

export interface GetActivateInfoResponse {
    activateInfo: ActivateInfo
}

export interface ActivateInfo {
    startTimestamp?: number
    endTimestamp?: number
    remainingTimestamp?: number
    licenceDetailName?: string
}

export interface GetActivateInfoRequest {
}

export interface ActivateRequest {
    code?: string
}

export interface ActivateResponse {
    done: boolean
}

export interface ListDynamicSimpleResponse {
    dynamicSimples: Array<DynamicSimple>
}

export interface DynamicSimple {
    ticket: string
    state: ProcessingState
    valid: boolean
    code: number
    message: string
}

export interface ListDynamicSimpleRequest {
    tickets: Array<string>
}

export interface CreatePressureStaticResponse {
    ticket: string
}

export interface CreatePressureStaticRequest {
    rawDataUrl?: string
}

export interface GetPressureRawDataCosStsResponse {
    key?: string
    sessionToken?: string
    expirationTime?: number
}

export interface GetPressureRawDataCosStsRequest {
    filename?: string
}

export interface GetPressureDynamicStandardGaitPhaseRequest {
}

export interface SplayfootValueRange {
    ranges: Array<Range>
}

export interface GetSplayfootValueRangeRequest {
}

export interface FootArchValueRange {
    ranges: Array<Range>
}

export interface GetFootArchValueRangeRequest {
}

export interface PressureDynamic {
    ticket?: string
    report: PressureDynamicReport
    insoleType?: string
    solution: PressureDynamicSolution
    state: ProcessingState
    creationTimestamp?: number
    updateTimestamp?: number
}

export interface PressureDynamicSolution {
    footArchSolutions: Array<Solution>
    splayfootSolutions: Array<Solution>
}

/* 解决方案 */
export interface Solution {
    title: string /* 标题 */
    content: string /* 内容 */
    note: string /* 要点 */
}

export interface GetPressureDynamicReportRequest {
    ticket?: string
}

export interface PressureDynamicNotificationResponse {
}

export interface PressureDynamicReport {
    ticket: string
    code: number
    message: string
    valid: boolean
    videoUrl: string
    left: Data
    right: Data
}

export interface GaitPhase {
    loadingResponse: number
    midStance: number
    terminalStance: number
}

export interface FootArch {
    value: number /* 足弓值 */
    level: Level /* 严重程度 */
}

export interface Splayfoot {
    value: number /* 内外八度数（注意是角度，不是弧度） */
    level: Level /* 严重程度 */
}

export interface CreatePressureDynamicResponse {
    ticket: string
}

export interface CreatePressureDynamicRequest {
    rawDataUrl?: string
}

export interface Data {
    footSide: FootSide
    thumbnail: Thumbnail
    cop: Cop
}

export interface Cop {
    x: Array<number>
    y: Array<number>
    centroidX: number
    centroidY: number
    meanX: number
    meanY: number
    stdX: number
    stdY: number
    distance: number
    speed: number
    lsf: number
    ellipse: CopEllipse
    physicalWidth: number
    physicalHeight: number
}

export interface CopEllipse {
    centerX: number
    centerY: number
    radiusX: number
    radiusY: number
    rotate: number
    eccentricity: number /* 偏心率 */
    area: number
}

export interface Cop {
    x: Array<number>
    y: Array<number>
    centroidX: number
    centroidY: number
    physicalWidth: number
    physicalHeight: number
}

export interface Data {
    anterior: Part
    posterior: Part
    whole: Part
    arch: FootArch
    varusTypeData: VarusTypeData
    thumbnail: Thumbnail
    processedThumbnailUrl: string
}

export interface VarusTypeData {
    rearInnerValue: number
    rearOuterValue: number
    varusType: VarusType /* 内外翻 */
}

export interface Part {
    area: number
    loadOverBothSide: number
    loadOverSelfSide: number
    pressureMax: number
    pressureMean: number
}

export interface Range {
    lower: number
    upper: number
    level: Level
    displaceName: string
}

export interface Range {
    lower: number
    upper: number
    level: Level
    displaceName: string
}

export interface Data {
    steps: Array<Step> /* 每一步的视频数据 */
    splayfoot: Splayfoot /* 八字脚 */
    footArch: FootArch /* 足弓 */
    varusType: VarusType /* 内外翻 */
    gaitPhase: GaitPhase /* 步相 */
}

export interface Step {
    index: number
}

export enum VersionType {
    VERSION_TYPE_UNKNOWN = 0,
    FIRMWARE_WIFI = 1, /* 固件-WiFi */
    FIRMWARE_COLLECTOR = 2, /* 固件-采集器 */
    APP_PHONE = 6,
    PC_DESKTOP = 7,
}

export enum FootSide {
    FOOT_SIDE_UNKNOWN = 0,
    LEFT = 1,
    RIGHT = 2,
    BOTH = 3,
}

export enum ProcessingState {
    NULL = 0,
    PROCESSING = 1,
    COMPLETED = 2,
}

/* 内外翻 */
export enum VarusType {
    VARUS_TYPE_UNKNOWN = 0,
    VARUS_TYPE_VARUS = 1, /* 足内翻 */
    VARUS_TYPE_VALGUS = 2, /* 足外翻 */
    VARUS_TYPE_NORMAL = 3, /* 正常 */
    VARUS_TYPE_VARUS_MILD = 4, /* 轻度后足内翻 */
    VARUS_TYPE_VALGUS_MILD = 5, /* 轻度后足外翻 */
}

export enum Level {
    UNKNOWN = 0,
    HIGH_SEVERE = 1, /* 重度高足弓 */
    HIGH = 2, /* 高足弓 */
    HIGH_MILD = 3, /* 轻度高足弓 */
    NORMAL = 4, /* 中足弓 */
    FLAT_MILD = 5, /* 轻度扁平足 */
    FLAT = 6, /* 扁平足 */
    FLAT_SEVERE = 7, /* 重度扁平足 */
}

export enum Level {
    INTOEING_SEVERE = 1, /* 重度内八 */
    INTOEING = 2, /* 内八 */
    MILD_INTOEING = 3, /* 轻度内八 */
    MILD_OUTTOEING = 5, /* 轻度外八 */
    OUTTOEING = 6, /* 外八 */
    OUTTOEING_SEVERE = 7, /* 重度外八 */
}

export class PressureServiceShell extends GrpcService {
    constructor(host: string, httpRequestDelegate: HttpRequestDelegate) {
        super(host, httpRequestDelegate)
    }
    
    /*  获取足弓值范围 */
    async getFootArchValueRange(request: GetFootArchValueRangeRequest): Promise<FootArchValueRange> {
        const method = "post"
        const path = "/algorithm.pressure.v2.PressureServiceShell/GetFootArchValueRange"
        return await this.call(method, path, request) as FootArchValueRange
    }
    
    /* 获取八字脚范围 */
    async getSplayfootValueRange(request: GetSplayfootValueRangeRequest): Promise<SplayfootValueRange> {
        const method = "post"
        const path = "/algorithm.pressure.v2.PressureServiceShell/GetSplayfootValueRange"
        return await this.call(method, path, request) as SplayfootValueRange
    }
    
    /* region 动态检测
 创建动态足压检测 */
    async createPressureDynamic(request: CreatePressureDynamicRequest): Promise<CreatePressureDynamicResponse> {
        const method = "post"
        const path = "/algorithm.pressure.v2.PressureServiceShell/CreatePressureDynamic"
        return await this.call(method, path, request) as CreatePressureDynamicResponse
    }
    
    /* 动态足压检测报告数据回调 */
    async pressureDynamicNotification(request: PressureDynamicReport): Promise<PressureDynamicNotificationResponse> {
        const method = "post"
        const path = "/algorithm.pressure.v2.PressureServiceShell/PressureDynamicNotification"
        return await this.call(method, path, request) as PressureDynamicNotificationResponse
    }
    
    /* 获取压力板检测报告详情 */
    async getPressureDynamicReport(request: GetPressureDynamicReportRequest): Promise<PressureDynamic> {
        const method = "post"
        const path = "/algorithm.pressure.v2.PressureServiceShell/GetPressureDynamicReport"
        return await this.call(method, path, request) as PressureDynamic
    }
    
    /* 获取压力板动态检测标准步相 */
    async getPressureDynamicStandardGaitPhase(request: GetPressureDynamicStandardGaitPhaseRequest): Promise<GaitPhase> {
        const method = "post"
        const path = "/algorithm.pressure.v2.PressureServiceShell/GetPressureDynamicStandardGaitPhase"
        return await this.call(method, path, request) as GaitPhase
    }
    
    /* 根据uuid列表获取动态检测有效性数据列表 */
    async listDynamicSimple(request: ListDynamicSimpleRequest): Promise<ListDynamicSimpleResponse> {
        const method = "post"
        const path = "/algorithm.pressure.v2.PressureServiceShell/ListDynamicSimple"
        return await this.call(method, path, request) as ListDynamicSimpleResponse
    }
    
    /* 获取存放压力检测原始数据的COS临时密钥 */
    async getPressureRawDataCosSts(request: GetPressureRawDataCosStsRequest): Promise<GetPressureRawDataCosStsResponse> {
        const method = "post"
        const path = "/algorithm.pressure.v2.PressureServiceShell/GetPressureRawDataCosSts"
        return await this.call(method, path, request) as GetPressureRawDataCosStsResponse
    }
    
    /* region 静态检测
 创建静态足压检测 */
    async createPressureStatic(request: CreatePressureStaticRequest): Promise<CreatePressureStaticResponse> {
        const method = "post"
        const path = "/algorithm.pressure.v2.PressureServiceShell/CreatePressureStatic"
        return await this.call(method, path, request) as CreatePressureStaticResponse
    }
    
    /* 静态足压检测报告数据回调 */
    async pressureStaticNotification(request: StaticReport): Promise<PressureStaticNotificationResponse> {
        const method = "post"
        const path = "/algorithm.pressure.v2.PressureServiceShell/PressureStaticNotification"
        return await this.call(method, path, request) as PressureStaticNotificationResponse
    }
    
    /* 获取静态足压报告数据 */
    async getPressureStaticReport(request: GetPressureStaticReportRequest): Promise<StaticReport> {
        const method = "post"
        const path = "/algorithm.pressure.v2.PressureServiceShell/GetPressureStaticReport"
        return await this.call(method, path, request) as StaticReport
    }
    
    /* region 平衡检测
 创建平衡足压检测 */
    async createPressureBalance(request: CreatePressureBalanceRequest): Promise<CreatePressureBalanceResponse> {
        const method = "post"
        const path = "/algorithm.pressure.v2.PressureServiceShell/CreatePressureBalance"
        return await this.call(method, path, request) as CreatePressureBalanceResponse
    }
    
    /* 平衡足压检测数据回调 */
    async pressureBalanceNotification(request: BalanceReport): Promise<PressureBalanceNotificationResponse> {
        const method = "post"
        const path = "/algorithm.pressure.v2.PressureServiceShell/PressureBalanceNotification"
        return await this.call(method, path, request) as PressureBalanceNotificationResponse
    }
    
    /* 获取平衡足压报告数据 */
    async getPressureBalanceReport(request: GetPressureBalanceReportRequest): Promise<BalanceReport> {
        const method = "post"
        const path = "/algorithm.pressure.v2.PressureServiceShell/GetPressureBalanceReport"
        return await this.call(method, path, request) as BalanceReport
    }
    
    /* region licence
 根据激活码激活(需要AccessToken) */
    async activate(request: ActivateRequest): Promise<ActivateResponse> {
        const method = "post"
        const path = "/algorithm.pressure.v2.PressureServiceShell/Activate"
        return await this.call(method, path, request) as ActivateResponse
    }
    
    /* 获取激活信息(需要AccessToken) */
    async getActivateInfo(request: GetActivateInfoRequest): Promise<GetActivateInfoResponse> {
        const method = "post"
        const path = "/algorithm.pressure.v2.PressureServiceShell/GetActivateInfo"
        return await this.call(method, path, request) as GetActivateInfoResponse
    }
    
    /* 获取激活记录（只有用户激活后才有激活记录，需要AccessToken） */
    async listActivateInfo(request: ListActivateInfoRequest): Promise<ListActivateInfoResponse> {
        const method = "post"
        const path = "/algorithm.pressure.v2.PressureServiceShell/ListActivateInfo"
        return await this.call(method, path, request) as ListActivateInfoResponse
    }
    
    /* region version
 更新版本信息 */
    async updateVersionInfo(request: UpdateVersionInfoRequest): Promise<UpdateVersionInfoResponse> {
        const method = "post"
        const path = "/algorithm.pressure.v2.PressureServiceShell/UpdateVersionInfo"
        return await this.call(method, path, request) as UpdateVersionInfoResponse
    }
    
    /* 获取根据版本类型获取最新版本信息 */
    async listLatestVersionInfoByType(request: ListLatestVersionInfoByTypeRequest): Promise<ListLatestVersionInfoByTypeResponse> {
        const method = "post"
        const path = "/algorithm.pressure.v2.PressureServiceShell/ListLatestVersionInfoByType"
        return await this.call(method, path, request) as ListLatestVersionInfoByTypeResponse
    }
    
    /* 根据版本类型和版本查看是否有新的版本 */
    async checkLatestVersionByTypeAndVersion(request: CheckLatestVersionByTypeAndVersionRequest): Promise<CheckLatestVersionByTypeAndVersionResponse> {
        const method = "post"
        const path = "/algorithm.pressure.v2.PressureServiceShell/CheckLatestVersionByTypeAndVersion"
        return await this.call(method, path, request) as CheckLatestVersionByTypeAndVersionResponse
    }
    
}
